function importAll(r) {
    return r.keys().map(r);
  }
const Estonia_L = importAll(require.context('../assets/photos/Estonia_L', false, /\.(png|jpe?g|svg|pdf|mp4)$/));

export default Estonia_L;